import { FormControlLabel, Switch, Typography } from '@mui/material';
import usePreferredFilter from '../../../zustand/Filter';
import React from 'react';
const Filter: React.FC = () => {
  const {
    isOnlyUpcoming,
    isMonthlySubscriptionPrefered,
    setIsMonthlySubscriptionPrefered,
    setIsOnlyUpcoming,
  } = usePreferredFilter();
  return (
    <>
      <Typography variant="caption">Games / matches </Typography> <br />
      <FormControlLabel
        value={isOnlyUpcoming}
        defaultChecked={isOnlyUpcoming}
        control={<Switch defaultChecked={isOnlyUpcoming} />}
        label="Only upcoming matches are considered"
        onChange={() => setIsOnlyUpcoming()}
      />{' '}
      <br />
      <Typography variant="caption">Provider abonemment </Typography> <br />
      <FormControlLabel
        value={isMonthlySubscriptionPrefered}
        control={<Switch defaultChecked={isMonthlySubscriptionPrefered} />}
        label="Show only monthly cancellable subscriptions if possible"
        onChange={() => setIsMonthlySubscriptionPrefered()}
      />
    </>
  );
};
export default Filter;
